import { InventoryLocation } from './InventoryLocation'
import type { InventoryTypeEnum } from './InventoryTypeEnum'
import { Product } from '../product/Product'
import { Field, Float, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { BaseEntity } from '../base/BaseEntity'
import { RelatedEntity } from '../base/RelatedEntity'

@ObjectType()
@modelOptions({ schemaOptions: { timestamps: true } })
export class InventoryTimeSeries extends BaseEntity {
  @Field(() => Product)
  @Prop({ type: RelatedEntity })
  product: ReturnType<() => Product>

  /**
   * The datetime when this entry is added, having the max value is the latest and the current inventory count
   * With this field available we can query at any point in time the quantity count
   */
  @Field(() => Date)
  @Prop({ type: Date })
  timeStamp: Date
  /**
   * Values can be positive or negative values,
   * Value can have decimal to support for cuts for some part
   */
  @Field(() => Float)
  @Prop({ type: Number })
  quantity: number

  /**
   * This is the result for the updating the previous runningQuantity, +/- with this.quantity
   */
  @Field(() => Float)
  @Prop({ type: Number })
  runningQuantity: number

  @Field(() => InventoryLocation)
  @Prop({ type: InventoryLocation })
  location?: InventoryLocation

  @Field(() => String)
  @Prop({ type: String })
  unitOfMeasure?: string
  /**
   * The reason for change update of quantity, the type of transaction like sales, purchase, adjustment, initialize
   */
  @Field(() => String)
  @Prop({ type: String })
  transactionType: InventoryTypeEnum
  /**
   * The transaction to reference where this change happens
   * When transaction like sales, purchase, adjustment, the value for this should be required
   */
  @Field(() => String)
  @Prop({ type: String })
  transactionRef: string
}
